<script setup lang="ts">
const props = defineProps({ content: String });
</script>
<template>
  <div class="inline-markup">
    <vue-showdown
      v-if="props.content"
      :markdown="props.content"
    />
  </div>
</template>
<style lang="scss">
.inline-markup {
  p {
    margin: 0;
  }
  a {
    display: inline !important;
  }
}
</style>
